module.exports = __webpack_public_path__ + "static/media/atl-studio.e167a41a.png";